module.exports = __webpack_public_path__ + "static/media/feather3.3fb447c8.png";